import React from 'react';
import { useSurvey } from '../../../context/SurveyContext';
import QuestionCard from './QuestionCard';
import { FileQuestion } from 'lucide-react';

const SurveyCanvas = () => {
  const { currentSurvey, reorderQuestions } = useSurvey();

  const handleDragStart = (e, index) => {
    e.dataTransfer.setData('dragIndex', index.toString());
    e.currentTarget.classList.add('dragging');
  };

  const handleDragEnd = (e) => {
    e.currentTarget.classList.remove('dragging');
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, dropIndex) => {
    e.preventDefault();
    const dragIndex = parseInt(e.dataTransfer.getData('dragIndex'));
    if (dragIndex !== dropIndex) {
      reorderQuestions(dragIndex, dropIndex);
    }
  };

  if (!currentSurvey?.questions?.length) {
    return (
      <div className="survey-canvas">
        <div className="canvas-empty">
          <FileQuestion size={48} />
          <p>Add questions from the sidebar to get started</p>
        </div>
      </div>
    );
  }

  return (
    <div className="survey-canvas">
      <div className="questions-list">
        {currentSurvey.questions.map((question, index) => (
          <QuestionCard
            key={question.id}
            question={question}
            index={index}
            onDragStart={(e) => handleDragStart(e, index)}
            onDragEnd={handleDragEnd}
            onDragOver={handleDragOver}
            onDrop={(e) => handleDrop(e, index)}
          />
        ))}
      </div>
    </div>
  );
};

export default SurveyCanvas;
